<!-- Assigned Connections Section -->
@if (
  showLeadsHistoryInline ||
  (recordDetails.assignees && recordDetails.assignees.length > 0)
) {
  <div
    class="assigned-connections-section"
    id="tour-assigned-to"
    [class.history-view]="showLeadsHistoryInline"
  >
    <div class="section-header">
      @if (!showLeadsHistoryInline) {
        <h4>Assigned To</h4>
        <span class="assignees-count">{{
          recordDetails.assignees?.length
        }}</span>
      } @else {
        <h4>Lead Assignment History</h4>
        <div class="history-stats">
          <span class="stats-badge">{{ getTotalEvents() }} Events</span>
          <span class="stats-badge"
            >{{ getTotalAssignments() }} Assignments</span
          >
          <span class="stats-badge"
            >{{ getTotalUnassignments() }} Unassignments</span
          >
        </div>
      }
    </div>

    @if (!showLeadsHistoryInline) {
      <!-- Current Assignees View -->
      <div class="connections-tags">
        @for (
          assignee of getSortedAssignees();
          track assignee.connection_name
        ) {
          <div
            class="connection-tag fade-in"
            [class.current-user]="isCurrentUserConnection(assignee)"
          >
            <div class="connection-info">
              <div class="connection-name">
                {{ assignee.display_name || assignee.connection_name }}
              </div>
              <div class="assignment-date">
                {{ formatAssignmentDate(assignee.assigned_on_utc) }}
              </div>
              @if (isAdminUser) {
                <div
                  class="lead-status-badge"
                  [attr.data-status]="assignee.lead_status ?? 'not-set'"
                >
                  {{ getLeadStatusLabel(assignee.lead_status) }}
                </div>
              }
            </div>
          </div>
        }
      </div>
    } @else {
      <!-- Leads History View -->
      <div class="leads-history-timeline">
        @if (isLoadingLeadsHistory) {
          <div class="loading-state">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24px"
              height="24px"
              viewBox="0 0 512 512"
              class="spin"
            >
              <path
                d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"
              />
            </svg>
            <span>Loading history...</span>
          </div>
        } @else if (leadsHistory && leadsHistory.length > 0) {
          <div class="timeline-container">
            @for (
              history of leadsHistory;
              track history.id + "_" + $index;
              let isFirst = $first;
              let isLast = $last
            ) {
              <div
                class="timeline-item slide-in"
                [class.assigned]="history.status"
                [class.unassigned]="!history.status"
                [class.first-item]="isFirst"
                [class.last-item]="isLast"
                [style.animation-delay]="$index * 0.03 + 's'"
              >
                <div class="timeline-connector" [class.hidden]="isLast"></div>
                <div class="timeline-marker">
                  <div
                    class="marker-dot"
                    [class.assigned]="history.status"
                    [class.unassigned]="!history.status"
                  >
                    @if (history.status) {
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 512 512"
                        fill="currentColor"
                      >
                        <path
                          d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
                        />
                      </svg>
                    } @else {
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 512 512"
                        fill="currentColor"
                      >
                        <path
                          d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
                        />
                      </svg>
                    }
                  </div>
                </div>
                <div class="timeline-content">
                  <div class="timeline-header">
                    <div class="user-info">
                      <h5 class="user-name">
                        {{ history.display_name }}
                      </h5>
                      <div class="assigned-user-name">
                        {{ history.updated_user.first_name }}
                        {{ history.updated_user.last_name }}
                      </div>
                    </div>
                    <div
                      class="status-badge"
                      [class.assigned]="history.status"
                      [class.unassigned]="!history.status"
                    >
                      {{ history.status ? "Assigned" : "Unassigned" }}
                    </div>
                  </div>
                  <div class="timeline-meta">
                    <span class="assignment-date">{{
                      formatAssignmentDate(history.updated_on_utc)
                    }}</span>
                  </div>
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="no-history-found">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              width="32"
              height="32"
            >
              <path
                d="M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"
              />
            </svg>
            <span>No assignment history found for this record.</span>
          </div>
        }
      </div>
    }
  </div>
}
